import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Scroll to top instantly when route changes
        window.scrollTo(0, 0);
        
        // Also scroll any other scrollable containers that might exist
        // This is useful for modals or specific containers
        const scrollableContainers = document.querySelectorAll('[data-scrollable]');
        scrollableContainers.forEach(container => {
            container.scrollTop = 0;
        });
        
        console.log(`Scrolled to top for route: ${pathname}`);
    }, [pathname]);

    return null; // This component doesn't render anything
};

export default ScrollToTop;